import { qs, listen, toggle, add, remove } from "@fluorescent/dom";
import { section } from "@/neon";
import { emit } from "@/neon/events";
import { animateGrid } from "@/lib/animation";

import sidebar from "@/lib/collection/sidebar";
import mobileFiltering from "@/lib/collection/mobile-filtering";
import filterHandler from "@/lib/filters/filter-handler";

const sel = {
  partial: "[data-js-partial]",
  sidebar: "[data-js-sidebar]",
  mainArea: ".search-results-wrapper",
};

section("search", {
  onLoad() {
    this.partial = qs(sel.partial, this.container);
    this.sidebar = sidebar(qs(sel.sidebar, this.container));
    this.mainArea = qs(sel.mainArea, this.container);
    this.pageHeader = qs("[data-section-type='header']");

    this.mobileFiltering = mobileFiltering(this.container);

    this.filterHandler = filterHandler({
      container: this.container,
      partial: this.partial,
      renderCB: this.__renderView.bind(this),
    });

    this.animateGrid = animateGrid(this.container);
  },

  __renderView(searchParams) {
    const url = `${window.location.pathname}?section_id=${this.container.dataset.sectionId}&${searchParams}`;
    const loading = qs(".collection__loading", this.container);

    add(loading, "is-active");

    fetch(url, { credentials: "include" })
      .then(res => res.text())
      .then(res => {
        this._updateURLHash(searchParams);
        const doc = new window.DOMParser().parseFromString(res, "text/html");
        const contents = qs(sel.partial, doc).innerHTML;
        this.partial.innerHTML = contents;

        remove(loading, "is-active");
        emit("collection:updated");
        this._scrollToTop();
      })
      .then(() => {
        this.animateGrid?.setupProductItems();
      });
  },

  _scrollToTop() {
    const topOfGrid = this.mainArea.offsetTop;
    const headerHeight = this.pageHeader.offsetHeight;
    const destination = topOfGrid - headerHeight - 20;

    if (document.documentElement.scrollTop > destination) {
      window.scrollTo({ top: destination, behavior: "smooth" });
    }
  },

  _updateURLHash(searchParams) {
    history.pushState(
      { searchParams },
      "",
      `${window.location.pathname}${searchParams && "?".concat(searchParams)}`
    );
  },
});
